import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PublicNav from "../components/PublicNav";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

export default function AcceptInvite() {
  const loc = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const token = new URLSearchParams(loc.search).get("token") || "";
  const [name, setName] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api("/org/accept-invite", { method: "POST", body: { token, name, password: pwd } });
      await refresh();
      nav("/app");
    } catch (e) { setErr(e.message || "Erreur"); }
    setLoading(false);
  };

  return (
    <>
      <PublicNav />
      <div className="auth-wrap">
        <div className="auth-visual">
          <div className="auth-visual-content">
            <h1>Rejoindre <em>l'équipe</em></h1>
            <p>Vous avez été invité(e) à rejoindre une entreprise sur Gestion Lagon. Créez votre accès en quelques secondes.</p>
          </div>
        </div>
        <div className="auth-form-wrap">
          <form className="auth-form" onSubmit={submit}>
            <h2>Accepter l'invitation</h2>
            {err && <div className="err">{err}</div>}
            <div className="field">
              <label>Votre nom</label>
              <input type="text" className="input" value={name} onChange={e=>setName(e.target.value)} required data-testid="accept-name" />
            </div>
            <div className="field">
              <label>Mot de passe (8 caractères minimum)</label>
              <input type="password" className="input" value={pwd} onChange={e=>setPwd(e.target.value)} minLength="8" required data-testid="accept-pwd" />
            </div>
            <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading || !token} data-testid="accept-submit">
              {loading ? <span className="spinner"></span> : "Rejoindre l'équipe"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
